import type { LibraryFilter } from './types';

export function libraryFilterHref(filter: LibraryFilter): string {
  if (filter === 'recents') {
    return '/library';
  }
  return `/library?filter=${filter}`;
}
